import { Stack, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { Panel } from "@poseidon/ui/components/Panel";
import { getDate } from "@poseidon/firebase/timestamp";
const getAddressLines = (address) => {
  return [
    address.flat ?? "",
    address.houseName ?? "",
    address.houseNumber ?? "",
    address.street_1 ?? "",
    address.street_2 ?? "",
    address.town ?? "",
    address.region ?? "",
    address.postcode ?? "",
  ].filter((v) => !!v);
};
export const AgreementSailorAddressManagement = ({ sailorAddresses }) => {
  return (
    <Panel collapsable title="Address History">
      <Stack spacing={2} mt={2}>
        {sailorAddresses
          ?.sort((a, b) => a.from > b.from)
          .map((address, index) => {
            const { createdAt, to, from, current } = address;
            return (
              <Stack key={index} spacing={1}>
                <Typography variant="title" fontWeight={500}>
                  {getDate(from)?.toLocaleDateString()} -{" "}
                  {current ? "Current" : getDate(to)?.toLocaleDateString()}
                </Typography>
                <Box p={1} sx={{ border: "1px solid #DDD" }}>
                  {getAddressLines(address).map((line, idx) => (
                    <Typography key={idx}>{line}</Typography>
                  ))}
                </Box>
                <Typography variant="caption">
                  Created at: {getDate(createdAt)?.toLocaleString()}
                </Typography>
              </Stack>
            );
          })}
      </Stack>
    </Panel>
  );
};
